import store from '@/store'

const Auth = {
  checkAuth (item) {
    let authData = store.state.account.authData
    if (authData.includes(item) || authData.includes(item + '/*') || authData.includes('/*')) {
      return true
    } else if (item !== '/admin/v1') {
      let index = item.lastIndexOf('/')
      if (index !== -1) {
        let prefix = item.slice(0, index)
        return this.checkAuth(prefix)
      }
      return false
    }

    return false
  }
}

export default Auth
